<template>
  <div class="info-volume-per-month">{{volumeValue}} GB storage</div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'PanelVolume',
  computed: {
    ...mapState(['volumeValue'])
  }
}
</script>
<style scoped>
.info-volume-per-month {
  font-weight: 600;
  color: #327bba;
  font-size: 24px;
}
</style>
